export enum ApiTabIndex {
  Omnichannel,
  Google,
  Adswizz,
  Dooh,
  Search,
  Social,
  Simplifi,
  Gam,
}
